module.exports = __webpack_public_path__ + "img/3.d2f3e010.jpg";